import { render, staticRenderFns } from "./mobile.vue?vue&type=template&id=bb43940a&scoped=true&"
import script from "./mobile.vue?vue&type=script&lang=js&"
export * from "./mobile.vue?vue&type=script&lang=js&"
import style0 from "./mobile.vue?vue&type=style&index=0&lang=less&"
import style1 from "./mobile.vue?vue&type=style&index=1&id=bb43940a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb43940a",
  null
  
)

export default component.exports